export default [
	{  // 订单列表
		path: 'order_list',
		name: 'm_order',
		props: route => route.query,
		component: () => import('@/pages/order/order_list_redirect')
	}, {  // 订单详情
		path: 'order_detail/:orderNumber',
		props: route => route.params,
		component: () => import('@/pages/order/order_detail_redirect')
	}, {  // 售后列表
		path: 'after_sale_list',
		name: 'm_aftersale',
		props: route => route.query,
		component: () => import('@/pages/order/after_sale_list')
	}, {  // 售后详情
		path: 'after_sale_detail/:type/:orderNumber',
		// props: route => route.params,
		props: route => Object.assign(route.query, route.params),
		component: () => import('@/pages/order/after_sale_detail')
	}, {  // 申请售后
		path: 'after_sale_apply/:orderNumber',
		props: route => route.params,
		component: () => import('@/pages/order/after_sale_apply')
	},{  // 订单商品评价列表
		path: 'order_evaluate_list',
		name: 'm_order_evaluate',
		component: () => import('@/pages/order/order_evaluate_list')
	}, {  // 订单商品评价详情
		path: 'order_evaluate_detail/:id',
		name: 'order_evaluate_detail',
		meta: {
			title: '订单商品评价详情'
		},
		props: route => route.params,
		component: () => import('@/pages/order/order_evaluate_detail')
	}, {  // 物流工具
		path: 'logistics_tool',
		name: 'm_logistics_tools',
		props: route => route.query,
		component: () => import('@/pages/order/logistics_tool')
	}, {  // 新增运费模板
		path: 'freight_template_add',
		component: () => import('@/pages/order/freight_template_add')
	}, {  // 编辑运费模板
		path: 'freight_template_edit/:id',
		props: route => route.params,
		component: () => import('@/pages/order/freight_template_edit')
	},{  // 发货中心订单列表
		path: 'order_delivery',
		name: 'm_order_delivery',
		props: route => route.query,
		component: () => import('@/pages/order/delivery_redirect')
	}, {  // 发货中心订单详情
		path: 'order_wait_delivery_detail/:orderNumber',
		props: route => route.params,
		component: () => import('@/pages/order/wait_delivery_detail_redirect')
	},{  // 待发订单列表
		path: 'retail_order',
		name: 'm_retail_order',
		props: route => route.query,
		component: () => import('@/pages/order/retail_order_list')
	}, {  // 订单详情
		path: 'retail_order_detail/:orderNumber',
		props: route => route.params,
		component: () => import('@/pages/order/retail_order_detail')
	}, {  //虚拟商品卡券核销
		path: 'service_card_detail',
		name: 'm_service_card',
		component: () => import('@/pages/order/service_card_detail')
	}, {  //虚拟商品卡券核销记录
		path: 'service_card_record',
		name: 'm_service_card_record',
		component: () => import('@/pages/order/service_card_record')
	}];